import { render, staticRenderFns } from "./DashboardRecentComments.vue?vue&type=template&id=37d5b0db&scoped=true"
import script from "./DashboardRecentComments.vue?vue&type=script&lang=js"
export * from "./DashboardRecentComments.vue?vue&type=script&lang=js"
import style0 from "./DashboardRecentComments.vue?vue&type=style&index=0&id=37d5b0db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d5b0db",
  null
  
)

export default component.exports